import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import { useMediaQuery } from 'react-responsive';

import { MEDIA_QUERY_SMALL_SCREEN } from 'client/constants/mediaQueries';

import {
  PROPERTY_CONDITION_REPORT_MAPPING,
  PROPERTY_CONDITION_REPORT_IN_PROGRESS_STATE,
} from 'common/marketingPartnerListingConstants';

import SrBox from 'client/components/SrBox';
import SrFlex from 'client/components/SrFlex';
import SrText from 'client/components/SrText';
import SrLink from 'client/components/SrLink/SrLink';

const SrPartnerListingPagePropertyConditionReport = ({
  onEdit,
  showEdit,
  marketingListing,
}) => {
  const isSmallScreen = useMediaQuery({
    query: MEDIA_QUERY_SMALL_SCREEN,
  });

  const propertyCondition = marketingListing.propertyConditionOverall
    ? PROPERTY_CONDITION_REPORT_MAPPING
      .find(({ value }) => value === marketingListing.propertyConditionOverall)
    : PROPERTY_CONDITION_REPORT_IN_PROGRESS_STATE;
  const inspectedAt = marketingListing.propertyConditionDateInspected
    && moment(marketingListing.propertyConditionDateInspected).format('MM/DD/YY');

  return (
    <SrBox
      borderRadius={isSmallScreen ? '14px' : '24px'}
      backgroundColor='white'
      padding='20px 20px 24px'
      boxShadow='0px 5px 21px rgba(25, 51, 64, 0.05)'
    >
      <SrFlex justify='between' width='100%' marginBottom='11px'>
        <SrText
          font='greycliff'
          weight='800'
          fontSize='18px'
          lineHeight='22px'
        >
          Condition Summary
        </SrText>
        {
          showEdit && (
            <SrText
              font='greycliff'
              weight='800'
              fontSize='13px'
              lineHeight='20px'
              color='blue300'
              cursor='pointer'
              onClick={onEdit}
            >
              Edit
            </SrText>
          )
        }
      </SrFlex>
      {
        propertyCondition && (
          <>
            <SrBox border='1px solid #E5E5E5' borderRadius='8px' padding='24px'>
              <SrFlex justify='between' marginBottom='10px'>
                <SrText
                  font='greycliff'
                  weight='700'
                  fontSize='24px'
                  lineHeight='28.8px'
                  color={propertyCondition.labelColor}
                >
                  {propertyCondition.label}
                </SrText>
                {
                  inspectedAt && (
                    <SrText
                      font='greycliff'
                      weight='700'
                      fontSize='14px'
                      lineHeight='21px'
                      color='grey'
                    >
                      Inspected on {inspectedAt}
                    </SrText>
                  )
                }
              </SrFlex>
              {
                propertyCondition.copyTitle && (
                  <SrBox marginTop='10px'>
                    <SrText
                      font='greycliff'
                      weight='700'
                      fontSize='14px'
                      lineHeight='21px'
                      color='grey'
                    >
                      {propertyCondition.copyTitle}
                    </SrText>
                  </SrBox>
                )
              }
              <SrBox marginTop='10px'>
                <SrText
                  font='greycliff'
                  weight='600'
                  fontSize='16px'
                  lineHeight='24px'
                >
                  {propertyCondition.copyText}
                </SrText>
              </SrBox>
            </SrBox>
            <SrFlex
              width='100%'
              borderRadius='14px'
              backgroundColor='#007AFF'
              height='50px'
              justify='center'
              align='center'
              marginTop='21px'
            >
              <SrLink
                to={marketingListing.propertyConditionUrl}
                target='_blank'
                className='propertyConditionReportLink'
              >
                View Condition Report
                <img src='/images/external-link-white.svg' alt='External link' height={16} />
              </SrLink>
            </SrFlex>
          </>
        )
      }
    </SrBox>
  );
};

SrPartnerListingPagePropertyConditionReport.propTypes = {
  onEdit: PropTypes.func,
  showEdit: PropTypes.bool,
  marketingListing: PropTypes.object.isRequired,
};

SrPartnerListingPagePropertyConditionReport.displayName = 'SrPartnerListingPagePropertyConditionReport';

export default SrPartnerListingPagePropertyConditionReport;
